<template>
  <FlexContainer
    :class="getClasses()"
    :horizGap="1"
    @click="$emit('toggleModal', modelValue, `${title} Hours`, props)"
  >
    <span>{{ title }}</span>
    <span>{{ modelValue }}</span>
  </FlexContainer>
</template>

<script>
import FlexContainer from "./FlexContainer.vue";

export default {
  props: {
    title: String,
    modelValue: Number,
    editable: {
      type: Boolean,
      default: true,
    },
  },

  components: { FlexContainer },

  methods: {
    getClasses() {
      return `badgeContainer ${this.editable ? "editable" : ""} ${
        this.modelValue < 0 ? "error" : ""
      }`;
    },
  },
};
</script>

<style scoped>
.badgeContainer {
  padding: 0.25rem 1rem;
  background: var(--vt-c-green);
  color: white;
  border-radius: 0.25rem;
  transition: 0.3s ease;

  &.editable {
    cursor: pointer;
    &:hover {
      background-color: var(--vt-c-green-darker);
    }
  }

  &.error {
    background: var(--vt-c-red);

    & > span:first-of-type {
      border-right: 1px solid var(--vt-c-red-dark);
    }
  }

  & > span:first-of-type {
    padding-right: 1rem;
    border-right: 1px solid var(--vt-c-green-dark);
  }
}
</style>
